import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import PerfilList from './PerfilList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import PerfilCadastrar from './PerfilCadastrar';
import { Messages } from 'primereact/messages';
import postPerfil from "../../service/postPerfil";
import putPerfil from '../../service/putPerfil';

export default function PerfilPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [perfil, setPerfil] = useState<any | null>(null);
  const labelButton = t('cadastrar')

  const savePerfil = (perfil: any) => {
    const acao = perfil.id ? putPerfil : postPerfil;
    acao(perfil).then(data => {
      if (data.includes('Erro')) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: t('erro') as string, detail: data, closable: false }
        ]);
      } else {
        setPerfil(null);
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'success', summary: t('sucesso') as string, detail: data, closable: false }
        ]);
      }
    })
  }

  const startContent = (
    <React.Fragment>
      <Button label={labelButton} icon="pi pi-plus" style={{ backgroundColor: '#183462' }} onClick={() => { setPerfil({}) }} />
    </React.Fragment>
  );

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray"><i className="pi pi-id-card" style={{ fontSize: '2.0rem' }}></i> {t('perfis')}</h1>
          </div>
        </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!perfil && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <PerfilList onEdit={(perfil: any) => { setPerfil(perfil); }}></PerfilList>
          </>
        )}
        {perfil && (
          <>
            <PerfilCadastrar perfil={perfil} onSave={savePerfil} onClose={() => { setPerfil(null) }}></PerfilCadastrar>
          </>
        )}
      </div>
    </Container>
  )
}
